import brand from "@/config/brand";

// Builds a plan from the meal-type × duration matrix in config/brand.js.
// Plan ids are "<typeId>-<durationId>", e.g. "breakfast-lunch-monthly".

const { mealPlans } = brand;

export const planTypes = () => mealPlans.types.filter((t) => t.visible);
export const planDurations = () => mealPlans.durations;

export function buildPlan(typeId, durationId) {
  const type = mealPlans.types.find((t) => t.id === typeId);
  const duration = mealPlans.durations.find((d) => d.id === durationId);
  if (!type || !duration) return null;

  const id = `${type.id}-${duration.id}`;
  const totalMeals = type.mealsPerWeek * duration.weeks;

  return {
    id,
    typeId: type.id,
    durationId: duration.id,
    typeLabel: type.label,
    durationLabel: duration.label,
    name: `${type.name} — ${duration.label}`,
    shortName: `${type.label} · ${duration.label}`,
    summary: type.summary,
    durationBlurb: duration.blurb,
    price: mealPlans.prices[id] ?? null,
    priceNote: mealPlans.priceNote,
    deliveryFee: mealPlans.deliveryFees[id] ?? null,
    cadence: duration.cadence,
    cadenceNote: duration.cadenceNote,
    renewal: duration.renewal,
    mealsPerWeek: type.mealsPerWeek,
    totalMeals,
    weeks: duration.weeks,
    rotationCount: type.rotationCount,
    collection: type.collection,
    deliveryModes: type.deliveryModes,
    badge: type.badge,
    featured: Boolean(type.featured && duration.featured),
    features: [
      `${totalMeals} meals in total (${type.mealsPerWeek} per week × ${duration.weeks} ${
        duration.weeks === 1 ? "week" : "weeks"
      })`,
      ...type.features.slice(1),
    ],
    cta: "Choose this plan",
  };
}

export function allPlans() {
  return planTypes().flatMap((t) => mealPlans.durations.map((d) => buildPlan(t.id, d.id)));
}

export function planFromId(id) {
  const match = allPlans().find((p) => p.id === id);
  if (match) return match;
  return buildPlan(mealPlans.defaultType, mealPlans.defaultDuration);
}

export const formatPrice = (plan) =>
  plan.price ? `₹${plan.price}` : mealPlans.pricePlaceholder;

export const includesBreakfast = (plan) => plan.collection !== "lunch";
export const includesLunch = (plan) => plan.collection !== "breakfast";
